export default __webpack_public_path__ + "static/media/turkeyV12.7181dc5f.jpg";